module.exports = __webpack_public_path__ + "media/how-it-works-2.864da441.mp4";